import { config } from '@config'
import { storage } from '@services/storageService'
import { HttpService } from '@services/HttpService'
import { VIPProductService } from '../constants/apiConstants'

export class CreateBuyingSessionAPIService {
  httpService = new HttpService()
  getCollectionAndActivities = async (seasonId, genderid) => {
    try {
      const url = `${config.buyingBoardServiceRestEndpoint}${VIPProductService.GET_COLLECTION_AND_ACTIVITIES}/season/${seasonId}/gender/${genderid}`
      const accessToken: string = storage.getItem('access_token')

      const response = await this.httpService.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      })
      return response
    } catch (e) {
      console.log(e)
    }
  }
  changePriceValidityDate = async (bsgId, bsgDate) => {
    const url = `${config.buyingBoardServiceRestEndpoint}buyingSessionGroup/updateBSGDate/${bsgId}`
    const accessToken: string = storage.getItem('access_token')
    return await this.httpService
      .post(
        url,
        { date: bsgDate },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        }
      )
      .then(response => response.data?.data)
  }
}
